import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FeedService } from '../../../services/feed.service';

@Component({
  selector: 'app-home-statistics-section',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './home-statistics-section.component.html',
})
export class HomeStatisticsSectionComponent {
  constructor(public feed: FeedService) {}
}
